import { render, staticRenderFns } from "./ListOf.vue?vue&type=template&id=2c27b913"
import script from "./ListOf.vue?vue&type=script&lang=js"
export * from "./ListOf.vue?vue&type=script&lang=js"
import style1 from "./ListOf.vue?vue&type=style&index=1&id=2c27b913&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports